import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import CareerPreferencesAd from '../containers/CareerPreferencesAd';
import createContainer from '../containers/create-prompt-container.jsx';

const Container = createContainer(CareerPreferencesAd);

const styles = StyleSheet.create({
    container: {
        width: '100%',
        maxWidth: 320,
        zIndex: 1,
        '@media (min-width: 768px)': {
            transform: 'translateX(-240px)',
        },
        '@media (min-width: 1010px)': {
            transform: 'translateX(-20px)',
        },
    },
    content: {
        minHeight: 430,
        marginTop: 10,
    },
    arrow: {
        left: 40,
        '@media (min-width: 768px)': {
            left: 'auto',
            right: 5,
        },
        '@media (min-width: 1010px)': {
            left: 58,
            right: 'auto',
        },
    },
    closeButtonStyle: {
        alignSelf: 'flex-end',
        '@media (min-width: 768px) and (max-width: 1010px)': {
            alignSelf: 'flex-start',
        },
    },
});

export default function CareerPreferencesAdView(props) {
    return (
        <div className={`absolute ${css(styles.container)}`}>
            <Container
                companyName={props.companyName}
                className={css(styles.content)}
                arrowClassName={css(styles.arrow)}
                onDismiss={props.onDismiss}
                closeButtonStyle={css(styles.closeButtonStyle)}
            />
        </div>
    );
}

CareerPreferencesAdView.propTypes = {
    companyName: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./views/CareerPreferencesAdView.jsx